/** sessionStorage key for new-session route/gate selection */
export const NEW_SESSION_ROUTE_KEY = 'newSession_routeSelection';
